module.exports = __webpack_public_path__ + "static/media/DejaVuSansMono.4ba93136.fnt";